export function getStudentAppBaseUrlForCurrentHost() {
  const alphaUrl =
    import.meta.env.VITE_STUDENT_APP_URL ||
    import.meta.env.VITE_STUDENT_APP_BETA_URL;
  const betaUrl =
    import.meta.env.VITE_STUDENT_APP_BETA_URL ||
    import.meta.env.VITE_STUDENT_APP_URL;

  if (typeof window === "undefined") {
    return alphaUrl;
  }

  const host = (window.location.hostname || "").toLowerCase();

  // Production dash should preview the production student app.
  if (host === "dash.zinduaschool.com") {
    return alphaUrl;
  }

  // Localhost, dash-test, preview hosts, staging, etc. should preview beta.
  return betaUrl;
}
